import { ISODateString } from "./ISODateString";
import { IPurchaseState } from "./PurchaseState";
import { ICustomerRelationship } from "./CustomerRelationship";

export enum CancellationReasonTypeEnum {
  PRODUCT = "Product",
  PRICE = "Price",
  DELIVERY = "Delivery",
  SERVICE = "Service",
  ALTERNATIVES = "Alternatives",
  OTHER = "Other",
}

export enum CancellationActionEnum {
  GIFT = "GIFT",
  SWAP = "SWAP",
  CHANGE_DATE = "CHANGE DATE",
  CANCEL = "CANCEL",
  DISCOUNT = "DISCOUNT",
  FREQUENCY_UPDATE = "FREQUENCY UPDATE",
  SKIP = "SKIP",
  CHANGE_ADDRESS = "CHANGE ADDRESS",
}

export enum PauseActionType {
  PAUSE = "PAUSE",
  SKIP = "SKIP",
  CHANGE_DATE = "CHANGE_DATE",
}

interface ITranslatable {
  [key: string]: string;
}

export interface ICancellationReason {
  id: string;
  reasonType: string;
  text?: ITranslatable | undefined;
  action: string;
  uiIdx: number;
  hasCustomerPrompt: boolean;
  discount?: number;
  isArchived: boolean;
}

export interface IPauseReason {
  id: string;
  text?: string;
  uiIdx: number;
  hasCustomerPrompt: boolean;
  isArchived: boolean;
}

export interface IUserCancellation {
  reasonText: string;
  action: string;
  stId: string;
  cancellationReasonId: string;
  createdDate?: ISODateString;
}

export interface IUserPause {
  reasonText: string;
  stId: string;
  pauseReasonId: string;
  createdDate?: ISODateString;
  actionType?: PauseActionType;
}

export interface ICancellationIntercept {
  id: string;
  headlineText: string;
  bodyText?: string;
  mediaUrl?: string;
  primaryButtonLabel: string;
  secondaryButtonLabel: string;
}

export enum CancellationInterceptOutcomeEnum {
  RETAINED = "RETAINED",
  CANCELLED = "CANCELLED",
}

export interface IUserCancellationInterceptOutcome {
  id: string;
  outcome: CancellationInterceptOutcomeEnum;
  subscription: IPurchaseState;
  customerRelationship: ICustomerRelationship;
  createdDate?: ISODateString;
}

export interface IPaginatedOutcomes {
  data: IUserCancellationInterceptOutcome[];
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  count: number;
}

export interface IOutcomeTotals {
  data: { outcome: CancellationInterceptOutcomeEnum; count: number }[];
}
